import axios from 'axios';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';
import { AlertDevice } from './alert.dto';

interface IAlertsService {
	nofifyAlertUpdate: (devices: AlertDevice[]) => Promise<void>;
	updateDigitalInput: (deviceId: number) => Promise<void>;
	verifyEmail: (email: string) => Promise<ServiceResponse>;
}

class AlertsService implements IAlertsService {
	async nofifyAlertUpdate(devices: AlertDevice[]): Promise<void> {
		await axios.post('/v2/alert/notify-update', { devices });
	}

	async updateDigitalInput(deviceId: number): Promise<void> {
		await axios.post('/v2/alert/notify-update-digital-input', { deviceId });
	}

	async verifyEmail(email: string): Promise<ServiceResponse> {
		const { data } = await axios.post<ServiceResponse>('/v2/email/verify', { email });
		return data;
	}
}

const AlertService = new AlertsService();

export default AlertService;
